// tslint:disable

function openShare(url, width, height) {
	const winTop = window.outerHeight / 2 - height / 2
	const winLeft = window.outerWidth / 2 - width / 2

	window.open(
		url,
		'sharer',
		'top=' +
			winTop +
			',left=' +
			winLeft +
			',toolbar=0,status=0,width=' +
			width +
			',height=' +
			height
	)
}

/**
 * @param text
 * @param url
 * @param hashtags
 *
 * @returns {string}
 */

function facebookUrl(url) {
	url = url ? url : window.location
	return (
		'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url)
	)
}

function blueskyUrl(copy?: string, url?: string, hashtags?: string[]) {
	const base = 'https://bsky.app/intent/compose?text='
	const args = []
	if (copy) args.push(copy)
	if (url) args.push(url)
	if (hashtags) args.push(hashtags.join(','))
	return base + encodeURIComponent(args.join(' '))
}

function linkedInUrl(url, title, description) {
	url = url ? url : window.location

	const args = []
	args.push('url=' + encodeURIComponent(url))
	args.push('title=' + encodeURIComponent(title || ''))
	args.push('summary=' + encodeURIComponent(description || ''))
	return 'https://www.linkedin.com/shareArticle?mini=true&' + args.join('&')
}

export const facebook = (url) => {
	openShare(facebookUrl(url), 580, 580)
}

export const linkedIn = (url, title?, description?) => {
	openShare(linkedInUrl(url, title, description), 500, 500)
}

export const facebookLink = (url) => {
	return {
		href: facebookUrl(url),
		onclick: (e) => {
			e.preventDefault()
			facebook(url)
		}
	}
}

export const bluesky = (copy?: string, url?: string, hashtags?: string[]) => {
	openShare(blueskyUrl(copy, url, hashtags), 520, 300)
}

export const blueskyLink = (
	url?: string,
	title?: string,
	description?: string[]
) => {
	return {
		href: blueskyUrl(url, title, description),
		onclick: (e) => {
			e.preventDefault()
			bluesky(url, title, description)
		}
	}
}

export const linkedInLink = (url, title?, description?) => {
	return {
		href: linkedInUrl(url, title, description),
		onclick: (e) => {
			e.preventDefault()
			linkedIn(url, title, description)
		}
	}
}

export const mailLink = (url) => {
	return {href: `mailto:?body=${url}`}
}

export const messengerLink = (url) => {
	return {href: `fb-messenger://share/?link=${url}`}
}
